import type { LocationCoordinates, ClockEvent } from '@libs/data-access/queries'
import { Loader, LocationPinIcon, Popover, ThemeIcon } from '@libs/ui/ds'
import { GOOGLE_MAPS_EMBED_KEY } from '@libs/utils/environments'
import React from 'react'
import type { FC } from 'react'

import { UnknownLocationControl } from './UnknownLocationControl'

type PopoverProps = {
  location_address?: string
  location_coordinates?: LocationCoordinates
}
export const LocationControlPopoverContent: FC<PopoverProps> = ({
  location_address,
  location_coordinates
}) => (
  <>
    <div className='mb-4 text-xs'>{location_address}</div>
    <div>
      <div className='absolute h-48 w-64' style={{ zIndex: -1 }}>
        <Loader.Overlay />
      </div>
      <iframe
        className='h-48 w-64'
        src={`https://www.google.com/maps/embed/v1/place?key=${GOOGLE_MAPS_EMBED_KEY}&q=${location_coordinates?.latitude},${location_coordinates?.longitude}`}
        title='Map'
      />
    </div>
  </>
)

type Props = {
  event: ClockEvent
}
export const LocationControl: FC<Props> = ({ event }) => {
  if (!event.location_coordinates) {
    return (
      <UnknownLocationControl event_occurred_at={event.event_occurred_at} />
    )
  }

  return (
    <Popover trigger='hover'>
      <Popover.Target>
        <ThemeIcon icon={<LocationPinIcon />} size='m' color='brand.green' />
      </Popover.Target>
      <Popover.Dropdown>
        <LocationControlPopoverContent
          location_address={event?.location_address}
          location_coordinates={event?.location_coordinates}
        />
      </Popover.Dropdown>
    </Popover>
  )
}
